import { all, call } from 'redux-saga/effects';
import vcloud from './vcloud/vcloudSagas';

export default function* sagas() {
	yield all([call(vcloud)]);
}
